
import { Component, Vue, Watch, Prop, Emit, PropSync, Model } from 'vue-property-decorator';
import { VariazioneDaComunicare, TipoVariazione, RigaDistintaPerComunicazioneVariazione, ItemDatiLookup, StatoVariazioneRigaDistinta,
  Distinta, RigaDistintaQtaTaglia, VariazioneDaComunicareQtaTaglia, RigaDistinta,VariazioneRigaDistinta, RigaInValidazione } from '@/models';
import { store, StoreActions } from '@/store'
import TabellaValori from './TabellaValori.vue';

@Component({
  components: {
    TabellaValori
  }
})
export default class ValidazioniMassive extends Vue{
    
  @PropSync('rigaDistinta') private riga!: RigaInValidazione;  

  @PropSync('variazione') private variazioneDiValidazione!: VariazioneRigaDistinta;          

  variazioniDaProcessare(riga: RigaDistinta): VariazioneRigaDistinta[]
  {
      if(riga.variazioniComunicate) {
          let indiceAttivo = riga.indiceVariazioneAttiva || 0;
          return riga.variazioniComunicate.filter(x => x && x.indice > indiceAttivo);
      }
      return [];
  }
  private cambiaStatoVariazione(riga: RigaInValidazione) {

    // hack: :( uso flag mostraCorrelate per gestire lo switch e nell'evento poter cambiare correttamente lo stato della variazione 
    if (this.variazioneDiValidazione.variazioniCorrelate.hasOwnProperty(riga.id)) {
        if(this.variazioneDiValidazione.variazioniCorrelate[riga.id].mostraCorrelate) {
            let rigaDaEliminare : any = {};
            this.variazioneDiValidazione.variazioniCorrelate[riga.id].mostraCorrelate = false; //bruttissimo
            Object.assign(rigaDaEliminare , this.variazioneDiValidazione.variazioniCorrelate[riga.id]);
            this.$set(this.variazioneDiValidazione.backupDict, riga.id, rigaDaEliminare);
            this.variazioneDiValidazione.variazioniCorrelate[riga.id]._accettata = true;
            this.variazioneDiValidazione.variazioniCorrelate[riga.id].mostraCorrelate = true;
            this.variazioneDiValidazione.variazioniCorrelate[riga.id].statoValidazione = StatoVariazioneRigaDistinta.RigaEliminataDaBC;               
        }
        else {    
            if(this.variazioneDiValidazione.variazioniCorrelate[riga.id].statoValidazione == StatoVariazioneRigaDistinta.RigaEliminataDaBC){
                if(this.variazioneDiValidazione.backupDict[riga.id]){
                    this.$delete(this.variazioneDiValidazione.variazioniCorrelate, riga.id);     
                    this.$set(this.variazioneDiValidazione.variazioniCorrelate, riga.id, this.variazioneDiValidazione.backupDict[riga.id]);   
                    this.$delete(this.variazioneDiValidazione.backupDict, riga.id);
                }
            }                     
        }
    }
  }
  private StatoVariazione = StatoVariazioneRigaDistinta;

  descProvenienza(riga:RigaInValidazione): string {
    let desc: string = "";
    
    let distinta = store.state.uiConsumi.listaDistinteCorrelate.find((distinta: Distinta) => distinta.id == riga.idDistintaAppartenenza);
    if(distinta) {
      // let rigaCorrelata = distinta.righeDistintaDPC.find((riga: RigaDistinta) => riga.innerRigaDistinta.idComponenteBga == idComponente);
      // MODELLO DI VENDITA (MOD. DISTINTA)
      desc = "Modello distinta correlata: <strong>";
      desc += distinta.idModello;
      desc += " - ";
      desc += distinta.descrizioneModello;
      // COLORE DI VENDITA (COL. DISTINTA)
      desc += "</strong>. Colore di vendita: <strong>";
      desc += distinta.idColore;
      desc += " - ";
      desc += distinta.descrizioneColore;
      desc += "</strong>"
    }

    return desc;
  }

  isModified(variazione: VariazioneDaComunicare): boolean {
    return variazione.variazioneRigaDistintaQtaTaglia.some((variazione: VariazioneDaComunicareQtaTaglia) =>
        variazione.qta != variazione.qtaModificata
    );
  }
  
  isDeleted(v: VariazioneRigaDistinta): boolean {
    return v.statoValidazione == StatoVariazioneRigaDistinta.RigaEliminataDalFornitore || 
      v.statoValidazione == StatoVariazioneRigaDistinta.RigaEliminataDaBC;
  }
  
  private applicaModifica(riga : RigaInValidazione, variazione: VariazioneRigaDistinta) {
        if(riga.quantitaPerTaglia) {
            // this.riga.quantitaPerTaglia.forEach(qtaTaglia => {
            //     let index = +qtaTaglia.indice - 1;
            //     this.variazioneDiValidazione.quantitaPerTagliaComunicate.splice(index, 1, variazione.quantitaPerTagliaComunicate[index]);
            // });
            for (let index = 0; index < riga.quantitaPerTaglia.length; index++) {
                this.variazioneDiValidazione.variazioniCorrelate[riga.id].quantitaPerTagliaComunicate.splice(index, 1, variazione.quantitaPerTagliaComunicate[+riga.quantitaPerTaglia[index].indice-1]);
            }
        }        
    }

    private mostraRiga(rigaCorrelata: RigaDistinta){
        let ret = false;        
        if(this.riga.variazioneGenerataDaValidazione || this.variazioneDiValidazione.statoValidazione == StatoVariazioneRigaDistinta.RigaEliminataDaBC){
            ret = !rigaCorrelata.contieneVariazioniDaValidare;
        } else{
            ret = rigaCorrelata.contieneVariazioniDaValidare;
        }
        return ret && !rigaCorrelata.inAttesaDiSincronizzazione;
    }

    private applicaCancellazione(riga: RigaInValidazione) {
        this.variazioneDiValidazione.variazioniCorrelate[riga.id].statoValidazione = StatoVariazioneRigaDistinta.RigaEliminataDaBC;
    }
    private annullaCancellazione(riga : RigaInValidazione) {
        this.variazioneDiValidazione.variazioniCorrelate[riga.id].statoValidazione = StatoVariazioneRigaDistinta.RigaEliminataDalFornitore;
        this.variazioneDiValidazione.variazioniCorrelate[riga.id]._accettata = false;
    }

    private accettaVariazione(riga :RigaInValidazione) {
        let variazione : any = {};
        Object.assign(variazione , this.variazioneDiValidazione.variazioniCorrelate[riga.id]);
        this.$set(this.variazioneDiValidazione.backupDict, riga.id, variazione);
        this.variazioneDiValidazione.variazioniCorrelate[riga.id]._accettata = true;
        if(this.variazioneDiValidazione.variazioniCorrelate[riga.id].statoValidazione == StatoVariazioneRigaDistinta.RigaModificataDalFornitore){
            this.variazioneDiValidazione.variazioniCorrelate[riga.id].statoValidazione = StatoVariazioneRigaDistinta.RigaModificataDaBC;
        }
    }

    private annullaVariazione(riga:RigaInValidazione) {      
        if(this.variazioneDiValidazione.backupDict[riga.id]){
            this.$delete(this.variazioneDiValidazione.variazioniCorrelate, riga.id);  
            this.$set(this.variazioneDiValidazione.variazioniCorrelate, riga.id, this.variazioneDiValidazione.backupDict[riga.id]);   
            this.$delete(this.variazioneDiValidazione.backupDict, riga.id);
        }       
    }
    // beforeDestroy() :void{
    //     Object.keys(this.backupDict).forEach(k => {
    //         this.$delete(this.variazioneDiValidazione.variazioniCorrelate, k);  
    //         this.$set(this.variazioneDiValidazione.variazioniCorrelate, k, this.backupDict[k]);   
    //         this.$delete(this.backupDict, k);
    //     });
    // }
}
